/* assets/mm-cmfp.js — CMFP-Schutz für Add-to-Cart-Formulare der mm-Sections (Sortenkarten, Duo-Banner)
   Custom-Mix-Produkte mit Festpreis (CMFP) brauchen im Warenkorb die _mix_*-Properties, sonst hat die
   Produktion keinen Inhalt. Für jedes form[data-mm-cmfp] liegt im Markup ein <template data-mm-cmfp-data>
   mit der PDP-Daten-Payload. Daraus wird – erst NACH Registrierung des Custom Elements (das Bundle merkt
   sich beim Modulstart das erste Element im DOM) – unsichtbar das PDP-Element <mymuesli-mix-cmfp-page>
   erzeugt. Es berechnet dieselben Properties wie die Produktseite; sie werden als hidden inputs in das
   Formular kopiert, das theme.js dann regulär per FormData an /cart/add schickt (Drawer, Zähler etc.).
   Klick vor Fertigstellung: Klick wird abgefangen (Capture-Phase), Button zeigt „busy“, nach Erhalt der
   Properties wird der Klick wiederholt. Ohne Properties wird NIE hinzugefügt – Fallback ist die Produktseite. */
(function () {
  'use strict';
  if (window.MMCmfp) return;
  var CMFP_TAG = 'mymuesli-mix-cmfp-page';
  var inEditor = !!(window.Shopify && window.Shopify.designMode);
  var hosts = {};      // variantId → host element
  var readiness = {};  // variantId → Promise<{id, properties} | {unavailable:true} | null>

  function toArray(list) { return Array.prototype.slice.call(list || []); }

  function templateFor(form) {
    var variantId = form.getAttribute('data-mm-cmfp'); if (!variantId) return null;
    var root = form.closest('[data-mm-cmfp-root]') || document;
    return root.querySelector('template[data-mm-cmfp-data][data-mm-cmfp-variant="' + variantId + '"]');
  }

  function cmfpDefined() {
    if (!window.customElements) return Promise.reject(new Error('cmfp-no-custom-elements'));
    if (customElements.get(CMFP_TAG)) return Promise.resolve();
    return Promise.race([
      customElements.whenDefined(CMFP_TAG),
      new Promise(function (_, reject) { setTimeout(function () { reject(new Error('cmfp-define-timeout')); }, 15000); })
    ]);
  }

  function ensureHost(variantId, tpl) {
    if (hosts[variantId]) return hosts[variantId];
    var host = document.createElement(CMFP_TAG);
    host.className = 'mm-cmfp-host';
    host.hidden = true;
    host.setAttribute('aria-hidden', 'true');
    ['customerId', 'language', 'country'].forEach(function (key) {
      if (tpl.dataset[key] !== undefined) host.dataset[key] = tpl.dataset[key];
    });
    /* Formular-Gerüst wie blocks/_mix-add-to-cart.liquid: das Bundle bindet an form[action='/cart/add']
       + Submit-Button und schreibt die Properties nach #mix-form-properties */
    var form = document.createElement('form');
    form.setAttribute('action', '/cart/add');
    form.setAttribute('method', 'post');
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    form.innerHTML = '<div id="mix-form-properties"></div><button type="submit" disabled hidden tabindex="-1"></button>';
    host.appendChild(form);
    host.appendChild(tpl.content.cloneNode(true));
    (tpl.closest('[data-mm-cmfp-root]') || document.body).appendChild(host);
    hosts[variantId] = host;
    return host;
  }

  function readProps(host) {
    var idInput = host.querySelector('#mix-form-properties input[name="id"]');
    if (!idInput || !idInput.value) return null;
    var properties = {};
    toArray(host.querySelectorAll('#mix-form-properties input[name^="properties["]')).forEach(function (input) {
      var m = input.name.match(/^properties\[(.+)\]$/);
      if (m) properties[m[1]] = input.value;
    });
    if (!properties._mix_uid) return null;
    return { id: idInput.value, properties: properties };
  }

  /* Ausverkauft (variant--soldout) oder Multi-Base-Sperre (Button ausgeblendet) */
  function unavailable(host) {
    var form = host.querySelector('form'); var btn = host.querySelector('form button[type="submit"]');
    if (form && form.classList.contains('variant--soldout')) return true;
    if (btn && btn.style.display === 'none') return true;
    return false;
  }

  function waitForProps(host, timeoutMs) {
    return new Promise(function (resolve) {
      var started = Date.now();
      (function tick() {
        if (unavailable(host)) return resolve({ unavailable: true });
        var res = readProps(host);
        if (res) return resolve(unavailable(host) ? { unavailable: true } : res);
        if (Date.now() - started > timeoutMs) return resolve(null);
        setTimeout(tick, 150);
      })();
    });
  }

  /* Properties als hidden inputs ins Ziel-Formular schreiben (idempotent) */
  function inject(form, res) {
    toArray(form.querySelectorAll('input[data-mm-cmfp-prop]')).forEach(function (n) { n.parentNode.removeChild(n); });
    Object.keys(res.properties).forEach(function (key) {
      var input = document.createElement('input');
      input.type = 'hidden'; input.name = 'properties[' + key + ']'; input.value = res.properties[key];
      input.setAttribute('data-mm-cmfp-prop', '');
      form.appendChild(input);
    });
    var idInput = form.querySelector('input[name="id"]');
    if (idInput && res.id) idInput.value = res.id;
    form.setAttribute('data-mm-cmfp-ready', 'true');
  }

  function ready(form) {
    var variantId = form.getAttribute('data-mm-cmfp');
    if (readiness[variantId]) return readiness[variantId];
    var tpl = templateFor(form);
    if (!tpl) { readiness[variantId] = Promise.resolve(null); return readiness[variantId]; }
    if (inEditor) { readiness[variantId] = Promise.resolve(null); return readiness[variantId]; }
    readiness[variantId] = cmfpDefined().then(function () {
      return waitForProps(ensureHost(variantId, tpl), 15000);
    }).catch(function () { return null; });
    return readiness[variantId];
  }

  function prepare(form) {
    if (form.__mmCmfp) return; form.__mmCmfp = true;
    ready(form).then(function (res) {
      if (res && !res.unavailable) { inject(form, res); form.dispatchEvent(new CustomEvent('mm:cmfp-ready', { bubbles: true })); }
      else form.setAttribute('data-mm-cmfp-ready', 'false');
    });
  }

  function fallbackToPdp(form) {
    var tpl = templateFor(form); var url = (tpl && tpl.getAttribute('data-mm-cmfp-url')) || form.getAttribute('data-mm-cmfp-url') || '';
    if (url && !inEditor) window.location.href = url;
  }

  function setBusy(btn, on) {
    if (!btn) return;
    if (on) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-busy'); }
    else { btn.removeAttribute('aria-busy'); btn.classList.remove('is-busy'); }
  }

  /* Capture-Phase: läuft vor dem delegierten Click-Handler von theme.js */
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest ? evt.target.closest('[data-add-to-cart]') : null; if (!btn) return;
    var form = btn.closest('form[data-mm-cmfp]'); if (!form || !form.getAttribute('data-mm-cmfp')) return;
    if (form.getAttribute('data-mm-cmfp-ready') === 'true') return; // Properties liegen im Formular → theme.js übernimmt
    evt.preventDefault(); evt.stopPropagation(); evt.stopImmediatePropagation();
    if (btn.getAttribute('aria-busy') === 'true') return;
    setBusy(btn, true);
    prepare(form);
    ready(form).then(function (res) {
      setBusy(btn, false);
      if (res && !res.unavailable) { inject(form, res); btn.click(); } // erneuter Klick → theme.js sendet mit Properties
      else fallbackToPdp(form);
    });
  }, true);

  function prepareAll(root) { toArray((root || document).querySelectorAll('form[data-mm-cmfp]')).forEach(function (f) { if (f.getAttribute('data-mm-cmfp')) prepare(f); }); }
  window.MMCmfp = { prepare: prepare, prepareAll: prepareAll, ready: ready };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { prepareAll(document); });
  else prepareAll(document);
  document.addEventListener('shopify:section:load', function (e) { prepareAll(e.target); });
})();
